import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastProvider } from "@/components/ui/toast";
import App from "./App";
import { ProviderFilterProvider } from "@/lib/provider";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // Never retry an auth failure -- it will fail identically every time.
        if (error instanceof Error && "status" in error && (error as { status: number }).status === 401) return false;
        return failureCount < 2;
      },
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ProviderFilterProvider>
          <ToastProvider position="bottom-end">
            <App />
          </ToastProvider>
        </ProviderFilterProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
